import { Route, Routes } from 'react-router-dom';
import CompareTray from './components/CompareTray';
import ProductTour from './components/ProductTour';
import SiteFooter from './components/SiteFooter';
import SiteHeader from './components/SiteHeader';
import { ComparisonProvider } from './hooks/ComparisonContext';
import { TourProvider } from './hooks/TourContext';
import { tx } from './i18n';
import CheckoutCancelledPage from './pages/CheckoutCancelledPage';
import CheckoutSuccessPage from './pages/CheckoutSuccessPage';
import ComparePage from './pages/ComparePage';
import AreaRedirectPage from './pages/AreaRedirectPage';
import AreaSearchPage from './pages/AreaSearchPage';
import HomePage from './pages/HomePage';
import NotFoundPage from './pages/NotFoundPage';
import ReportPage from './pages/ReportPage';

/**
 * Application shell and routing.
 *
 * <p>The comparison provider wraps everything because the header counter and the compare page must
 * agree about how many free slots are left.
 */
export default function App() {
  return (
    <ComparisonProvider>
      {/* Outside the shell, because the footer's replay link and every screen's tour read it. */}
      <TourProvider>
        <div className="app">
          {/* First stop for a keyboard or screen reader, before the header and the language menu. */}
          <a className="skip-link" href="#main">
            {tx(
              'Skip to the content',
              'İçeriğe geç',
              'Przejdź do treści',
              'Saltar para o conteúdo',
              'Saltar al contenido',
            )}
          </a>
          <SiteHeader />
          <main className="app__main" id="main" tabIndex={-1}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/compare" element={<ComparePage />} />
              <Route path="/areas" element={<AreaSearchPage />} />
              <Route path="/area/:outcode" element={<AreaRedirectPage />} />
              <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
              <Route path="/checkout/cancelled" element={<CheckoutCancelledPage />} />
              <Route path="/report/:analysisId" element={<ReportPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </main>
          <SiteFooter />
          <CompareTray />
          <ProductTour />
        </div>
      </TourProvider>
    </ComparisonProvider>
  );
}
